// src/pages/Leave/LeaveDashboardReports.jsx
import React from 'react';
import LeaveHistory from './LeaveHistory';

export default function LeaveDashboardReports() {
  return (
    <div className="p-1">
      
      {/* Leave History */}
      <LeaveHistory />
    </div>
  );
}